<template>
  <form action="" class="w-75 mx-auto">
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="family" class="form-label">Grupo de formas asociado:</label>
      </div>
      <div class="col-sm-7">
        <select class="form-select" id="family" v-model="family">
          <option value="0" selected>Opciones disponibles...</option>
          <option v-for="family in families" :key="family._id" v-bind:value="family.id">
            {{ family.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-5">
        <label for="imageForm" class="form-label">Nombre de la forma:</label>
      </div>
      <div class="col-sm-7">
        <input type="text" v-model="imageForm" class="form-control" id="imageForm" />
      </div>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-5">
        <label for="imageFile" class="form-label">Imagen de la forma:</label>
      </div>
      <div class="col-sm-7">
        <input type="file" @change="previewFile" class="form-control" id="imageFile" ref="file" />
      </div>
    </div>
    <h4 class="mt-3">Servicios sobre la forma</h4>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2 mt-4">
        <h6>Oxicorte:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceFlamingCut"
          v-model="imgServiceFlamingCut" />
        <label class="form-check-label" for="imgServiceFlamingCut">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Corte CNC <i>(Plasma)</i>:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSevicePlasmaCutting"
          v-model="imgServicePlasmaCutting" />
        <label class="form-check-label" for="imgServicePlasmaCutting">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Corte láser:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceLaserCutting"
          v-model="imgServiceLaserCutting" />
        <label class="form-check-label" for="imgServiceLaserCutting">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Soldadura de electrodo:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceWeldingElect"
          v-model="imgServiceWeldingElect" />
        <label class="form-check-label" for="imgServiceWeldingElect">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Soldadura <i>MIG</i>:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceWeldingMig"
          v-model="imgServiceWeldingMig" />
        <label class="form-check-label" for="imgServiceWeldingMig">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <h6>Rolado recto:</h6>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSeviceRolled"
          v-model="imgServiceRolled" />
        <label class="form-check-label" for="imgServiceRolled">Aplica</label>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-3 col-12 align-items-center p-2">
        <label for="imgServicePunching1" class="form-label">Punzonado menor a <i>40mm</i>:</label>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSevicePunching1"
          v-model="imgServicePunching1" />
        <label class="form-check-label" for="imgServicePunching1">Aplica</label>
      </div>
      <div class="col-sm-3 col-12 align-items-center p-2">
        <label for="imgServicePunching2" class="form-label">Punzonado mayor a <i>40mm</i>:</label>
      </div>
      <div class="form-check form-switch col-sm-3 col-12 mb-2">
        <input class="form-check-input ms-5" type="checkbox" role="switch" id="imgSevicePunching2"
          v-model="imgServicePunching2" />
        <label class="form-check-label" for="imgServicePunching2">Aplica</label>
      </div>
    </div>
    <div class="mt-3 mb-2">
      <button class="btn btn-danger" @click.prevent="saveProfileImg">
        Añadir nueva forma
      </button>
    </div>
  </form>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      familyDefault: "Perfiles",
      families: [],
      family: "",
      imageForm: "",
      imageFile: undefined,
      currentFile: undefined,
      imgServiceFlamingCut: false,
      imgServicePlasmaCutting: false,
      imgServiceLaserCutting: false,
      imgServiceWeldingElect: false,
      imgServiceWeldingMig: false,
      imgServiceRolled: false,
      imgServicePunching1: false,
      imgServicePunching2: false,
    };
  },
  methods: {
    previewFile(event) {
      this.imageFile = this.$refs.file.files;
      // console.log(this.imageFile);
      this.currentFile = this.imageFile.item(0);
    },
    async saveProfileImg() {
      let formData = new FormData();
      //console.log("Dentro del post..."+this.imageFile);
      formData.append("img_form_family_id", this.family);
      formData.append("imageFormName", this.imageForm);
      formData.append("imageFile", this.currentFile);
      formData.append("imageName", this.currentFile.name);
      formData.append(
        "imgServiceFlameCutting",
        this.imgServiceFlamingCut ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServicePlasmaCutting",
        this.imgServicePlasmaCutting ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServiceLaserCutting",
        this.imgServiceLaserCutting ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServiceWeldingElectrode",
        this.imgServiceWeldingElect ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServiceWeldingMig",
        this.imgServiceWeldingMig ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServiceRolled",
        this.imgServiceRolled ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServicePunching1",
        this.imgServicePunching1 ? "aplica" : "no_aplica"
      );
      formData.append(
        "imgServicePunching2",
        this.imgServicePunching2 ? "aplica" : "no_aplica"
      );
      try {
        let res = await axios.post(
          RUTA_SERVIDOR + "api/profile/image/create",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log(res.data);
        if (!res.data) {
          console.log("There has been a different error with the data.");
        } else {
          alert("Forma: " + this.imageForm + ", guardada con exito!");
          this.cleanFields();
          this.$router.push("/Admin/ProfileImages");
        }
      } catch (err) {
        console.log(`There has been an error ${err}`);
      }
    },
    cleanFields() {
      this.family = "";
      this.imageForm = "";
      this.imageFile = null; // o this.imageFile = undefined;
      this.currentFile = null;
      this.imageDistances = 0;
      this.imgServiceFlamingCut = false;
      this.imgServicePlasmaCutting = false;
      this.imgServiceLaserCutting = false;
      this.imgServiceWeldingElect = false;
      this.imgServiceWeldingMig = false;
      this.imgServiceRolled = false;
      this.imgServicePunching1 = false;
      this.imgServicePunching2 = false;
    }
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/imgFormFamily/list", {
        params: {
          imgFormFamily_type: this.familyDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.families = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>